@if (supervisorState) {
    @switch (supervisorState.subPhase) {
        @case (SupervisorSubPhase.WaitingForSupervisor) {
            <app-supervisor-panel
                [inverseColors]="true"
                [message]="'Scan supervisor card to continue'"
                (backClicked)="cancelActionClicked.emit()"
            />
        }

        @case (SupervisorSubPhase.ConfirmAction) {
            @switch (supervisorState.selectedAction) {
                @case (SupervisorAction.ContinueGame) {
                    <app-supervisor-panel
                        [title]="'Continuing game'"
                        [message]="'Scan supervisor card to continue game'"
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.VoidGame) {
                    <app-supervisor-panel
                        [title]="'Voiding game and change shoe'"
                        [message]="'Scan supervisor card to confirm changes and continue'"
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.FreeHand) {
                    <app-supervisor-panel
                        [title]="'Freeing hand'"
                        [message]="'Scan supervisor card to confirm'"
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.ChangeResult) {
                    @if (supervisorState.changedGameResult) {
                        <app-supervisor-panel
                            [title]="'Result changed'"
                            [message]="'Scan supervisor card to confirm changes and continue'"
                            (backClicked)="cancelActionClicked.emit()"
                        />
                    }
                }

                @case (SupervisorAction.CloseTable) {
                    <app-supervisor-panel
                        [title]="'Closing ' + currentGame?.displayName"
                        [message]="'Scan supervisor card to confirm changes and continue'"
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }
            }
        }

        @case (SupervisorSubPhase.ConfirmGameSelection) {
            <app-supervisor-panel
                [title]="'Selected game: ' + supervisorState.selectedGame?.displayName"
                [message]="'Scan supervisor card to confirm the selection and continue'"
                (backClicked)="cancelActionClicked.emit()"
            />
        }
    }
}
